import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/app',
        name: 'app',
        component: () => import('@/view/home/myHome')
    },
    {
        path: '/',
        name: 'home',
        component: () => import('@/view/home/myHome')
    },
]


const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
